import { ToastContainer } from "react-toastify";
import { AuthProvider } from "./contexts/AuthContext";
import Router from "./routes/Router";
import "./styles/main.scss";
import { createTheme } from "@mui/material";
import MuiRTLThemeProvider from "./MUIThemProvider";
import { SectionThemeScope } from "./theme/section";
// import ErrorBoundary from "./ErrorBoundary";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterMomentJalaali } from "@mui/x-date-pickers/AdapterMomentJalaali";
import { AdapterDateFnsJalali } from "@mui/x-date-pickers/AdapterDateFnsJalali";

import { faIR } from "@mui/x-date-pickers/locales";

function App() {
  return (
    <>
      <MuiRTLThemeProvider>
        <LocalizationProvider
          dateAdapter={AdapterDateFnsJalali}
          localeText={
            faIR.components.MuiLocalizationProvider.defaultProps.localeText
          }
        >
          {/* <ErrorBoundary> */}
          <SectionThemeScope />
          <ToastContainer limit={3} />
          <AuthProvider>
            <div className="app">
              <Router basename />
            </div>
          </AuthProvider>
          {/* </ErrorBoundary> */}
        </LocalizationProvider>
      </MuiRTLThemeProvider>
    </>
  );
}

export default App;
